import styled from 'styled-components';
import {
	media,variables
} from 'styleUtils';

export const inputTransition = () => `
  &:focus ~ label, &.filled ~ label { 
    font-size: 0.675rem;
    top: -12px;
    left: 0;
    position: absolute;
    transition: all .2s ease;
    z-index: 1;
    color: $darkGrey;
  }
`;

export const defaultInputStyles = (props) => `
  -webkit-appearance: none;
  box-shadow: none;
  border: none;
  border-radius: 0;
  cursor: pointer;
  border-bottom: 1px solid ${variables.darkGrey};
  font-size: 1rem;
  z-index: 1;
  color: ${variables.darkGrey};
  width: 100%;

  :focus {
    outline: none;
    box-shadow: inset 0 -1px 0 0 ${props => props.light ? variables.lineColor : variables.darkGrey};
  }
  ${media.desktop`
    font-size: 1rem;
  `}
`;

export const Label = styled.label`
  position: absolute;
  top: 1rem;
  left: 0;
  font-size: 1rem;
  transition: all .2s ease;
  z-index: 0;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-top: 20px;
  margin-bottom: 10px;

  span:after {
    display:block;
    content: ' ';
    height: 2px;
    box-shadow: inset 0 -2px 0 0 $darkGrey;
    transform: scaleX(0);
    transition: transform .2s ease-out;
  }

  &:focus-within > span:after {
    box-shadow: inset 0 -2px 0 0 $darkGrey;
    transform: scaleX(1);
    transition: transform .2s ease-in;
  }
`;
